import { apiSlice } from "../../_api/apiSlice";

export const dataApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getData: builder.mutation({
      query: () => ({
        url: "/data/",
        method: "GET",
      }),
    }),
    getCountryCodes: builder.query({
      query: () => ({
        url: "https://restcountries.com/v3.1/all?fields=name,flags,cca2,idd",
        method: "GET",
      }),
      transformResponse: (response) => {
        // Transform the response to match the expected format
        // Filter out countries without proper idd data and handle duplicates

        const transformed = response
          .filter((country) => country.idd && country.idd.root)
          .map((country) => {
            // Combine root and first suffix to get complete phone code
            const phoneCode =
              country.idd.suffixes && country.idd.suffixes.length > 0
                ? country.idd.root + country.idd.suffixes[0]
                : country.idd.root;

            return {
              countryName: country.name.common,
              flag: country.flags.svg,
              flagPng: country.flags.png,
              code: country.cca2,
              value: phoneCode,
              label: phoneCode,
              // Create a unique identifier for countries with same phone code
              uniqueId: `${country.cca2}-${phoneCode}`,
            };
          });

        // Remove duplicates based on uniqueId
        const uniqueCountries = transformed.filter(
          (country, index, self) =>
            index === self.findIndex((c) => c.uniqueId === country.uniqueId)
        );

        return uniqueCountries;
      },
    }),
    getSelfServeUsersFilters: builder.mutation({
      query: () => ({
        url: "/data/getSelfServeUsersFilters",
        method: "GET",
      }),
    }),
    getUpsellDownsellFilters: builder.mutation({
      query: () => ({
        url: "/data/getUpsellDownsellFilters",
        method: "GET",
      }),
    }),
    getMarketsFilters: builder.mutation({
      query: () => ({
        url: "/data/marketsFilters",
        method: "GET",
      }),
    }),
    getBillingFilters: builder.mutation({
      query: () => ({
        url: "/data/getBillingFilters",
        method: "GET",
      }),
    }),
    getFeaturesFilters: builder.mutation({
      query: () => ({
        url: "/data/getFeaturesFilters",
        method: "GET",
      }),
    }),
    getProductsFilters: builder.mutation({
      query: () => ({
        url: "/data/getProductsFilters",
        method: "GET",
      }),
    }),
    getCompanyFilters: builder.mutation({
      query: () => ({
        url: "/data/getCompanyFilters",
        method: "GET",
      }),
    }),
    getPlanFilters: builder.mutation({
      query: () => ({
        url: "/data/getPlanFilters",
        method: "GET",
      }),
    }),
    getUsageSourcesFilters: builder.mutation({
      query: () => ({
        url: "/data/getUsageSourcesFilters",
        method: "GET",
      }),
    }),
    getUsageCompilationsFilters: builder.mutation({
      query: () => ({
        url: "/data/getUsageCompilationFilters",
        method: "GET",
      }),
    }),
    getSubscriptionsFilters: builder.mutation({
      query: () => ({
        url: "/data/getSubscriptionsFilters",
        method: "GET",
      }),
    }),
    getImportsFilters: builder.mutation({
      query: () => ({
        url: "/data/getImportsFilters",
        method: "GET",
      }),
    }),
    getProposalFilters: builder.mutation({
      query: () => ({
        url: "/data/getProposalFilters",
        method: "GET",
      }),
    }),
    getUsersFilters: builder.mutation({
      query: () => ({
        url: "/data/getUsersFilters",
        method: "GET",
      }),
    }),
    getInvoicesFilters: builder.mutation({
      query: () => ({
        url: "/data/getInvoicesFilters",
        method: "GET",
      }),
    }),
    getPaymentsFilters: builder.mutation({
      query: () => ({
        url: "/data/getPaymentsFilters",
        method: "GET",
      }),
    }),
    getContactsFilters: builder.mutation({
      query: () => ({
        url: "/data/getContactsFilters",
        method: "GET",
      }),
    }),
    getRolesFilters: builder.mutation({
      query: () => ({
        url: "/data/getRolesFilters",
        method: "GET",
      }),
    }),
    getExportsFilters: builder.mutation({
      query: () => ({
        url: "/data/getExportsFilters",
        method: "GET",
      }),
    }),
    getBillingLogicFilters: builder.mutation({
      query: () => ({
        url: "/data/getBillingLogicFilters",
        method: "GET",
      }),
    }),
    getUsageCollectionFilters: builder.mutation({
      query: () => ({
        url: "/data/getUsageCollectionFilters",
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetSelfServeUsersFiltersMutation,
  useGetMarketsFiltersMutation,
  useGetDataMutation,
  useGetBillingFiltersMutation,
  useGetFeaturesFiltersMutation,
  useGetProductsFiltersMutation,
  useGetCompanyFiltersMutation,
  useGetPlanFiltersMutation,
  useGetUsageSourcesFiltersMutation,
  useGetSubscriptionsFiltersMutation,
  useGetProposalFiltersMutation,
  useGetUsersFiltersMutation,
  useGetInvoicesFiltersMutation,
  useGetPaymentsFiltersMutation,
  useGetContactsFiltersMutation,
  useGetUsageCompilationsFiltersMutation,
  useGetUpsellDownsellFiltersMutation,
  useGetImportsFiltersMutation,
  useGetRolesFiltersMutation,
  useGetExportsFiltersMutation,
  useGetBillingLogicFiltersMutation,
  useGetUsageCollectionFiltersMutation,
  useGetCountryCodesQuery
} = dataApiSlice;
